import React, { useState } from "react";

import { Link } from "react-router-dom";
import Iframe from "react-iframe";
import { useTranslation } from "react-i18next";
import Sidenav from "./../../components/Sidenav";
import "./../weeks.css";

function Week4() {
  const { t } = useTranslation();
  const [video, setVideo] = useState(
    "https://www.youtube.com/embed/cF6YkH-8vFk?rel=0&amp;showinfo=0"
  );
  return (
    <React.Fragment>
      <Sidenav />
      <div className="center-week container">
        <h1 id="week-4">{t("week")} 4</h1>

        <div
          className="border embed-responsive embed-responsive-16by9"
          data-video=""
          style={{ maxWidth: "720px" }}
        >
          <Iframe
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen=""
            className="embed-responsive-item"
            src={t("Lec4")}
          ></Iframe>
        </div>

        <ul className="mt-5">
          <li data-marker="-">
            {t("Lecture")}
            <ul>
              <li data-marker="*">
                <a href="http://cdn.cs50.net/2020/fall/lectures/4/lecture4.mp3">
                  Audio
                </a>
              </li>
              <li data-marker="*">
                <Link to={"note4"}>{t("Notes")}</Link>
              </li>
              <li data-marker="+">
                {t("Slides")}
                <ul>
                  <li data-marker="*">
                    <a href="https://docs.google.com/presentation/d/16ZAYKGzoSY4PQD8qpw_FMEdx7-R3nxMnn6hrZ-3ydt8/edit?usp=sharing">
                      {t("Google-slides")}
                    </a>
                  </li>
                  <li data-marker="*">
                    <a href="https://cdn.cs50.net/2020/fall/lectures/4/lecture4.pdf">
                      PDF
                    </a>
                  </li>
                </ul>
              </li>
              <li data-marker="+">
                {t("Source-Code")}
                <ul>
                  <li data-marker="*">
                    <a href="https://cdn.cs50.net/2020/fall/lectures/4/src4/">
                      {t("Index")}
                    </a>
                  </li>
                  <li data-marker="*">
                    <a href="https://cdn.cs50.net/2020/fall/lectures/4/src4.pdf">
                      PDF
                    </a>
                  </li>
                  <li data-marker="*">
                    <a href="https://cdn.cs50.net/2020/fall/lectures/4/src4.zip">
                      Zip
                    </a>
                  </li>
                </ul>
              </li>
              <li data-marker="*">
                <a href="http://cdn.cs50.net/2020/fall/lectures/4/lang/en/lecture4.srt">
                  Subtitles
                </a>
              </li>
              <li data-marker="*">
                <a href="http://cdn.cs50.net/2020/fall/lectures/4/lang/en/lecture4.txt">
                  Transcript
                </a>
              </li>
              <li data-marker="+">
                {t("Video")}
                <ul>
                  <li data-marker="*">
                    <a href="https://video.cs50.io/NKTfNv2T0FE?screen=7y81o-2rjeM">
                      CS50 Video Player
                    </a>
                  </li>
                  <li data-marker="+">
                    MP4
                    <ul>
                      <li data-marker="*">
                        <a href="http://cdn.cs50.net/2020/fall/lectures/4/lecture4-360p.mp4">
                          360p
                        </a>
                      </li>
                      <li data-marker="*">
                        <a href="http://cdn.cs50.net/2020/fall/lectures/4/lecture4-720p.mp4">
                          720p
                        </a>
                      </li>
                      <li data-marker="*">
                        <a href="http://cdn.cs50.net/2020/fall/lectures/4/lecture4-1080p.mp4">
                          1080p
                        </a>
                      </li>
                      <li data-marker="*">
                        <a href="http://cdn.cs50.net/2020/fall/lectures/4/lecture4-4k.mp4">
                          4K
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li data-marker="*">
                    <a href="https://youtu.be/NKTfNv2T0FE">YouTube</a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li data-marker="-">
            {t("Short")}
            <ol>
              <li>
                <a href="https://www.youtube.com/embed/u_atXp-NF6w">
                  Hexadecimal
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/embed/XISnO2YhnsY">Pointers</a>
              </li>
              <li>
                <a href="https://www.youtube.com/embed/crxfzK3Oc9M">
                  Defining Custom Types
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/embed/xa4ugmMDhiE">
                  Dynamic Memory Allocation
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/embed/aCPkszeKRa4">
                  Call Stacks
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/embed/bOF-SpEAYgk">
                  File Pointers
                </a>
              </li>
            </ol>
          </li>
          <li data-marker="*">
            <a href="https://cs50.harvard.edu/x/2021/labs/4/">Lab 4</a>
          </li>
          <li data-marker="*">
            <Link to={"pset4"}>{t("Problem")} 4</Link>
          </li>
        </ul>
      </div>
    </React.Fragment>
  );
}

export default Week4;
